import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga';

import { rootReducer } from "../Store/Reducers";
import { rootSaga } from "./Sagas";

// Middleware: Redux Saga
const sagaMiddleware = createSagaMiddleware();

// Redux: Store
const Store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

// Run Middleware
sagaMiddleware.run(rootSaga);

export default Store;